<template>
<div>
    <div
        class="w-full p-8 lg:pl-16 flex items-center justify-between flex-1 bg-white"
    >
        <div class="flex-1 min-w-0 mt-4">
            <h2 class="text-2xl break-words font-bold text-gray-900 sm:text-3xl">Gesamtabrechnung</h2>
            <p class="mb-6">(In folgendem Formular sind ausschließlich die Zahlen aus der <span class="font-bold underline">Finanzierungsrechnung</span> des Rechnungsabschlusses anzugeben)</p>
           
        </div>
        <div class="flex-shrink-0 flex w-48 md:w-56 pl-4">
            <img
                src="@/assets/img/logo.jpg"
                width="100%"
                alt="Logo mkm - musik &amp; kunst schulen management"
            />
        </div>
    </div>
    <div class="bg-primary">
        <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8" >
            <transition name="fade" v-if="formbehaviour.musikschuleIsSet">
                <div
                    class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                    v-show="formbehaviour.alertrequired"
                >
                    <div class="md:grid md:grid-cols-1 md:gap-3">
                        <div class="md:col-span-1">
                            <h3 class="leading-3">
                                Bitte überprüfen Sie Ihre Eingabe!
                            </h3>
                        </div>
                    </div>
                </div>
            </transition>

            <div v-if="formbehaviour.musikschuleIsSet"
                class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
            >
                <div class="md:grid md:grid-cols-1 md:gap-3">
                    <div class="md:col-span-1">
                        <h3 class="leading-5">
                            Der Druck der Gesamtabrechnung ist erst möglich, nachdem die Gesamtabrechnung abgeschlossen und übermittelt worden ist. Ab diesem Zeitpunkt können keine Daten mehr verändert werden, außer nach Freischaltung durch die MKM Musik & Kunst Schulen Management Niederösterreich GmbH.
                        </h3>
                    </div>
                </div>
            </div>

            <div v-if="formbehaviour.xmlError"
                class="mt-2 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
            >
                <h3 class="text-red-500 leading-3">
                    {{ formbehaviour.xmlError }}
                </h3>
            </div>

            <div v-if="formbehaviour.sendError"
                class="mt-2 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
            >
                <h3 class="col-span-6 text-red-500 leading-5">
                    Die Übermittlung ist fehlgeschlagen. {{ formbehaviour.sendError }} Bitte versuchen Sie es erneut oder wenden Sie sich direkt an foerderung@mkmnoe.at.
                </h3>
            </div>

            <ValidationObserver ref="form" v-if="formbehaviour.musikschuleIsSet">
                <form-section title="Allgemein">
                    <text-input columns="6" readonly :value="gesamtabrechnung.musikschuleName" label="A1. Musikschule">gesamtabrechnung.musikschuleName</text-input>
                    <text-input v-show="false" readonly columns="2" :value="gesamtabrechnung.jahr" label="A2. Jahr"></text-input>
                </form-section>
                <form-section title="Summe">
                    <text-input readonly columns="3" v-model="formattedNumbers.summeAusgaben"  tooltip="Dieses Feld wird automatisch berechnet." label="B1. Mittelverwendung"></text-input>
                    <text-input readonly columns="3" v-model="formattedNumbers.summeEinnahmen"  tooltip="Dieses Feld wird automatisch berechnet." label="B2. Mittelaufbringung"></text-input>
                    <text-input readonly columns="3" v-model="formattedNumbers.differenz" 
                        label="B3. Differenz (Mittelaufbringung - Mittelverwendung)" tooltip="Darf nicht negativ sein, da eine Musikschule nicht negativ bilanzieren kann. Minus muss über die Gemeindebeiträge ausgeglichen werden" ></text-input>
                    <h3 v-if="formbehaviour.differenzNegativ" class="col-span-6 text-red-500 leading-3">
                        Die Differenz darf nicht kleiner als € 0 sein!
                    </h3>
                </form-section>
                <form-section title="Einzahlungen">
                    <text-input :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="3" v-model="formattedNumbers.einnahmenFoerderungen" @input="onPreisChanged($event, 'einnahmenFoerderungen'), calculate()" rules="decimal:2|required" 
                        label="C1. Musikschulförderung inkl. Strukturförderung gem § 12ff. NÖ Musikschulgesetz 2000 (VRV +861)" tooltip="Basis- und Wochenstundenförderung, Instrumenten-Strukturförderung (Mangelinstrumentenförderung), Talenteförderung, Sondervertragsförderung, etc.)"></text-input>
                    <text-input :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="3" v-model="formattedNumbers.einnahmenSchulgeld" @input="onPreisChanged($event, 'einnahmenSchulgeld'), calculate()" rules="decimal:2|required" 
                        label="C2. Elternbeiträge (VRV +810)"
                        tooltip="Schulgeldbeiträge und Zahlungen für Leihinstrumente"></text-input>
                    <text-input :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="3" v-model="formattedNumbers.einnahmenSonstige" @input="onPreisChanged($event, 'einnahmenSonstige'), calculate()" rules="decimal:2|required" label="C3. Sonstige (VRV +829)"></text-input>
                    <text-input :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="3" v-model="formattedNumbers.einnahmenGemeindebeitraege" @input="onPreisChanged($event, 'einnahmenGemeindebeitraege'), calculate()" rules="decimal:2|required" label="C4. Gemeindebeiträge (VRV +862)"></text-input>
                    <text-input :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="3" v-model="formattedNumbers.einnahmenGebaeude" @input="onPreisChanged($event, 'einnahmenGebaeude'), calculate()" rules="decimal:2|required" 
                        label="C5. Weitere Förderungen ohne Musikschulförderung (VRV +861)" tooltip="Transfers von Ländern, Landesfonds und Landeskammern"></text-input>
                </form-section>
                <form-section title="Auszahlungen">
                    <text-input 
                        label="D. Leistungen für Lehrpersonal gem. Klasse 5 VRV 15"
                        tooltip="Lehrpersonal, inkl. aller damit verbundenen Leistungen wie Bezüge (+510) Sachbezüge (+540), Reisegebühren (+724) oder Dienstjubiläen (+566)"
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.lehrPersonal" @input="onPreisChanged($event, 'lehrPersonal'), calculate()" rules="decimal:2|required"></text-input>
                    <text-input 
                        label="E. Leistungen für Verwaltungspersonal gem. Klasse 5 VRV 15"
                        tooltip="Verwaltungspersonal, inkl. aller damit verbundenen Leistungen wie Bezüge (+510) Sachbezüge (+540), Reisegebühren (+724) oder Dienstjubiläen (+566)"
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.verwaltungsPersonal" @input="onPreisChanged($event, 'verwaltungsPersonal'), calculate()" rules="decimal:2|required"></text-input>
                    <text-input 
                        label="F. Anlagen gem. Klasse 0" 
                        tooltip="Anlagevermögen ab 1.000 Euro, zB: Ausstattung (+04), Ankauf Instrumente (+042)"
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.anlagenKlasseNull" @input="onPreisChanged($event, 'anlagenKlasseNull'), calculate()" rules="decimal:2|required"></text-input>
                    <text-input class="ml-10" 
                        label="F1. davon Ankauf Instrumente:" 
                        tooltip="Hier die Ausgaben für das Instrumentarium zusätzlich gesondert ausweisen."
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.anlagenKlasseNullWartenStimmen" @input="onPreisChanged($event, 'anlagenKlasseNullWartenStimmen'), calculate()" rules="decimal:2|required"></text-input>
                   <text-input 
                        label="G. Gebrauchs- und Verbrauchsgüter sowie Handelswaren gem. Klasse 4 VRV 15" 
                        tooltip="Anlagevermögen bis 1.000 Euro, zB: geringw. Wirtschaftsgüter (+40), Betriebsstoffe (+45), Ankauf Instrumente (400)"
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.gebrauchVerbrauchHandel" @input="onPreisChanged($event, 'gebrauchVerbrauchHandel'), calculate()" rules="decimal:2|required"></text-input>
                    <text-input class="ml-10" 
                        label="G1. davon Ankauf Instrumente, Warten und Stimmen:" 
                        tooltip="Hier die Ausgaben für das Instrumentarium zusätzlich gesondert ausweisen."
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.anteilInstrumenteWartenStimmen" @input="onPreisChanged($event, 'anteilInstrumenteWartenStimmen'), calculate()" rules="decimal:2|required"></text-input>
                    <text-input 
                        label="H. Sonstiger Verwaltungs- und Betriebsaufwand gem. Klasse 6 VRV 15" 
                        tooltip="zB: Instandhaltung (+618), Energiebezüge (+60), Telekommunikation (+63), Versicherungen (+670)"
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.verwaltungBetriebKlasse6" @input="onPreisChanged($event, 'verwaltungBetriebKlasse6'), calculate()" rules="decimal:2|required"></text-input>
                    <text-input 
                        label="I. Sonstiger Verwaltungs- und Betriebsaufwand gem. Klasse 7 VRV 15" 
                        tooltip="zB: Öffentliche Abgaben (+71), Entgelte sonstige Leistungen (AKM, GIS, etc., +728)), Miete/Pacht (+70), sonstige Aufwendungen (+729)"
                        :readonly="gesamtabrechnung.druckerstatus || formbehaviour.gesamtabrechnungGesendet" columns="4" v-model="formattedNumbers.verwaltungBetriebKlasse7" @input="onPreisChanged($event, 'verwaltungBetriebKlasse7'), calculate()" rules="decimal:2|required"></text-input>                
                </form-section>
                <form-section title="Anlage 3b - Kontenplan und Kontenzuordnungen - Gemeinden der Voranschlags- und Rechnungsabschlussverordnung 2015 - VRV 2015">
                    <text-block class="text-lg md:p-6 col-span-6 text-blue-500 hover:text-blue-400" :content="textbausteinfuer('gesamtabrechnung.verordnung')"></text-block>                 
                </form-section>
                <form-section title="Upload Rechnungsabschluss">
                    <file-upload
                        label="Bitte laden Sie hier Ihr GHD bzw. GVB File im XML-Format hoch."
                        columns="4"
                        :maxSize="50"
                        accept="text/xml"
                        @size-exceeded="onSizeExceeded"
                        @metadata="onRechnungsabschluss"
                        @fileloaded="onRechnungsabschlussLoad"
                    />
                </form-section>
                
            </ValidationObserver>
            <div v-if="formbehaviour.gesamtabrechnungGesendet || gesamtabrechnung.druckerstatus" 
                class="mt-0 mb-4 bg-blue-200 border-2 border-blue-300 px-4 py-4 sm:rounded-lg sm:p-4"
            >
                <div class="md:grid md:grid-cols-1 md:gap-3">
                    <div class="md:col-span-1">
                        <h3 class="leading-5">
                            Die PDF Datei muss abgespeichert, ausgedruckt, unterschrieben, eingescannt und an die E-Mail: foerderung@mkmnoe.at gesendet oder per Post an die MKM Musik & Kunst Schulen Management Niederösterreich GmbH übermittelt werden!
                        </h3>
                    </div>
                </div>
            </div>
            <div v-if="formbehaviour.musikschuleIsSet"
                class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 grid grid-cols-1 grid-rows-2 gap-6 md:grid-cols-3 md:grid-rows-1">
                <button v-if="!formbehaviour.gesamtabrechnungGesendet && !gesamtabrechnung.druckerstatus" class="md:col-start-2 justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-md sm:leading-5"
                    @click="openSendModal()">Gesamtabrechnung abschließen</button>
                <button v-else class="md:col-start-2 inline-flex justify-center w-full rounded-md border border-indigo-500 px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-md sm:leading-5"
                    @click="generatePdf()">Pdf herunterladen</button>
            </div>
            <transition name="fade">
            <div
                v-show="formbehaviour.showSendModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.showSendModal"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.showSendModal"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
                >
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Ansuchen absenden
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Nach dem Absenden können die Daten nicht mehr verändert werden, außer nach Freischaltung durch die MKM Musik & Kunst Schulen Management Niederösterreich GmbH. Nach dem Absenden, kann die Gesamtabrechnung ausgedruckt werden.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                        v-if="!formbehaviour.sending"
                    >
                        <span
                            class="flex w-full rounded-md shadow-sm sm:col-start-2"
                        >
                            <button
                                @click="sendGesamtabrechnung()"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Absenden
                            </button>
                        </span>
                        <span
                            class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
                        >
                            <button
                                @click="formbehaviour.showSendModal = false"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
                <transition name="fade">
            <div
                v-show="formbehaviour.showPrintModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.showPrintModal"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.showPrintModal"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Die PDF Datei muss abgespeichert, ausgedruckt, unterschrieben, eingescannt und an die E-Mail: foerderung@mkmnoe.at gesendet oder per Post an die MKM Musik & Kunst Schulen Management Niederösterreich GmbH übermittelt werden!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                        <span class="flex w-full rounded-md shadow-sm sm:col-start-2">
                            <button
                                @click="generatePdf()"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Pdf herunterladen
                            </button>
                        </span>
                        <span
                            class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
                        >
                            <button
                                @click="formbehaviour.showPrintModal = false"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.showGesamtabrechnungMissing"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.showGesamtabrechnungMissing"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.showGesamtabrechnungMissing"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
                >
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Fehlende Gesamtabrechnung
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Die Information für die Gesamtabrechnung konnte nicht gefunden werden.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        </div>
    </div>
</div>
    
</template>

<script>
import FormHeader from '@/components/forms/FormHeader.vue';
import FormSection from '@/components/forms/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import TextBlock from '@/components/inputs/TextBlock.vue';
import FileUpload from '@/components/inputs/FileUpload.vue';
import DropDown from '@/components/inputs/DropDown.vue';
import * as JsPDF from 'jspdf';


export default {
    name: 'Form',
    inject: ['service'],
    props: {
        hash: {
            id: String,
            required: false,
        }
    },
    data: function () {
        return {
            formbehaviour: {
                sending: false,
                successful: false,
                showSendModal: false,
                alertrequired: false,
                musikschuleIsSet: false,
                showGesamtabrechnungMissing: false,
                gesamtabrechnungGesendet: false,
                showPrintModal: false,
                differenzNegativ: false,
                xmlError: '',
                sendError: ''
            },
            formdata: {
                textbausteine: [],
            },
            formattedNumbers: {           
                verwaltungsPersonal: null,
                lehrPersonal: null,
                anlagenKlasseNull: null,
                anlagenKlasseNullWartenStimmen: null,
                gebrauchVerbrauchHandel: null,
                anteilInstrumenteWartenStimmen: null,
                verwaltungBetriebKlasse6: null,
                verwaltungBetriebKlasse7: null,

                einnahmenGebaeude: null,
                einnahmenSonstige: null,
                einnahmenSchulgeld: null,
                einnahmenGemeindebeitraege: null,
                einnahmenFoerderungen: null,
                differenz: null,
                summeEinnahmen: null,
                summeAusgaben: null,
            },
            gesamtabrechnung: {
                musikschuleName: null,
                musikschuleId: null,

                verwaltungsPersonal: null,
                lehrPersonal: null,
                anlagenKlasseNull: null,
                anlagenKlasseNullWartenStimmen: null,
                gebrauchVerbrauchHandel: null,
                anteilInstrumenteWartenStimmen: null,
                verwaltungBetriebKlasse6: null,
                verwaltungBetriebKlasse7: null,
            
                einnahmenGebaeude: null,
                einnahmenSonstige: null,
                einnahmenSchulgeld: null,
                einnahmenGemeindebeitraege: null,
                einnahmenFoerderungen: null,
                differenz: null,
                summeEinnahmen: null,
                summeAusgaben: null,

                jahr: null,
                schuleKuerzel: null,
                druckerstatus: null,

                xmlGesamtabrechnungFile: {
                    subject: 'Upload - Rechnungsabschluss',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
            }
        }
    },
    methods: {
        async sendGesamtabrechnung() {
            try {
                this.formbehaviour.sendError = '';
                this.formbehaviour.sending = true;
                await this.service.gesamtabrechnung.senden(this.gesamtabrechnung);
                this.formbehaviour.showSendModal = false;
                this.formbehaviour.gesamtabrechnungGesendet = true;    
                this.formbehaviour.showPrintModal = true;

            }
            catch(error) {
                this.formbehaviour.gesamtabrechnungGesendet = false;
                this.formbehaviour.showSendModal = false;
                this.formbehaviour.sending = false;

                if (error.response.data.exceptionMessage) {
                    this.formbehaviour.sendError = error.response.data.exceptionMessage;
                }
                else {
                    this.formbehaviour.sendError = error;
                }

                window.scrollTo(0, 0);                
            }
            finally {
                this.formbehaviour.showSendModal = false;
                this.formbehaviour.sending = false;
            }
        },
        async openSendModal() {
            var validation = await this.$refs.form.validate();

            if ((parseFloat(this.gesamtabrechnung.differenz)) < 0)
            {
                this.formbehaviour.differenzNegativ = true;
                window.scrollTo(0,0);
                return;
            }

            if (!this.gesamtabrechnung.xmlUploadOptional && (!this.gesamtabrechnung.xmlGesamtabrechnungFile || !this.gesamtabrechnung.xmlGesamtabrechnungFile.body)) {
                this.formbehaviour.xmlError = 'Der Upload des Rechnungsabschlusses im XML-Format ist verpflichtend.';
                window.scrollTo(0, 0);
                return;
            }
            else {
                this.formbehaviour.xmlError = '';
            }

            if (this.gesamtabrechnung.xmlGesamtabrechnungFile.filename && !this.gesamtabrechnung.xmlGesamtabrechnungFile.filename.toUpperCase().endsWith(".XML")) {
                this.formbehaviour.xmlError = 'Für den Upload des Rechnungsabschlusses muss eine Datei im XML-Format angegeben werden.';
                window.scrollTo(0, 0);
                return;
            }

            if (!validation) {
                this.formbehaviour.alertrequired = true;
                window.scrollTo(0,0);
                return;
            }

            this.formbehaviour.showSendModal = true;
        },
        onPreisChanged(newValue, propertyName) {
            newValue = (newValue.split('€').join('')).split(' ').join('');
            var lastItemIsComma = newValue[newValue.length - 1] == ','; 
            
            var value = this.getAmountFromFormattedNumber(newValue);

            if (!value) {
                this.formattedNumbers[propertyName] = newValue;
                this.gesamtabrechnung[propertyName] = 0;
                return;
            }

            var firstItemIsMinus = value < 0;

            this.gesamtabrechnung[propertyName] = value.toString();
            if (firstItemIsMinus) {newValue = newValue.slice(1);}

            var parts = newValue.toString().split(',');
            var numbersBeforeDecimal = parts[0].split(".").join("");
            var numberOfDots = Math.trunc(numbersBeforeDecimal.length / 3) - 1;

            if ((numbersBeforeDecimal.length % 3) > 0) {
                numberOfDots+= 1;
            }

            for (var i = numberOfDots; i > 0; i--) {
                var indexForComma = numbersBeforeDecimal.length - (i*3);
                numbersBeforeDecimal = numbersBeforeDecimal.slice(0, indexForComma) + '.' + numbersBeforeDecimal.slice(indexForComma);
            } 

            this.formattedNumbers[propertyName] = numbersBeforeDecimal;
                
            if (parts.length > 1) {
                this.formattedNumbers[propertyName] = numbersBeforeDecimal + "," + parts[1];
            }
            
            if(lastItemIsComma){
                this.formattedNumbers[propertyName] = numbersBeforeDecimal + ",";
            } 
            
            if (firstItemIsMinus)
            {
                this.formattedNumbers[propertyName] = '-' + this.formattedNumbers[propertyName];
            }
            this.formattedNumbers[propertyName] = '€ ' + this.formattedNumbers[propertyName];
        },
        onRechnungsabschluss(file) {
            this.gesamtabrechnung.xmlGesamtabrechnungFile.mimeType = file.type;
            this.gesamtabrechnung.xmlGesamtabrechnungFile.filename = file.name;
        },
        onRechnungsabschlussLoad(dataUri) {
            this.gesamtabrechnung.xmlGesamtabrechnungFile.body = dataUri;
        },
        onSizeExceeded(size) {
            alert(`Die Datei mit ${size}MB ist zu groß. (Maximal 10 MB)`);
        },
        fetchGesamtabrechnungByHash(hash) {
            const {data} = this.service.gesamtabrechnung.byhash(hash);
            this.gesamtabrechnung = data;
            
            if (!this.gesamtabrechnung.xmlGesamtabrechnungFile) {
                this.gesamtabrechnung.xmlGesamtabrechnungFile = {
                    subject: 'Upload - Rechnungsabschluss',
                    filename: null,
                    mimeType: null,
                    body: null,
                };
            }
        },
        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('gesamtabrechnung')
                .textbloecke();
            this.formdata.textbausteine = data
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found.content
        },
        calculate() {
            var einnahmen = this.getEinnahmenSum();
            var ausgaben = this.getAusgabenSum();
            var differenz = einnahmen - ausgaben;
            var einnahmenString = einnahmen.toFixed(2).toString().replace('.', ',');
            var ausgabenString = ausgaben.toFixed(2).toString().replace('.', ',');
            var differenzString = differenz.toFixed(2).toString().replace('.', ',');
            this.onPreisChanged(einnahmenString, 'summeEinnahmen');
            this.onPreisChanged(ausgabenString, 'summeAusgaben');
            this.onPreisChanged(differenzString, 'differenz');
        },
        getEinnahmenSum() {
            var einnahmen = (this.gesamtabrechnung.einnahmenGebaeude ? parseFloat(this.gesamtabrechnung.einnahmenGebaeude) : 0) +
                (this.gesamtabrechnung.einnahmenSchulgeld ? parseFloat(this.gesamtabrechnung.einnahmenSchulgeld) : 0) +
                (this.gesamtabrechnung.einnahmenGemeindebeitraege ? parseFloat(this.gesamtabrechnung.einnahmenGemeindebeitraege) : 0) +
                (this.gesamtabrechnung.einnahmenFoerderungen ? parseFloat(this.gesamtabrechnung.einnahmenFoerderungen) : 0) +
                (this.gesamtabrechnung.einnahmenSonstige ? parseFloat(this.gesamtabrechnung.einnahmenSonstige) : 0);
            return einnahmen;
        },
        getAusgabenSum() {
            var ausgaben = (this.gesamtabrechnung.lehrPersonal ? parseFloat(this.gesamtabrechnung.lehrPersonal) : 0) +
            (this.gesamtabrechnung.verwaltungsPersonal ? parseFloat(this.gesamtabrechnung.verwaltungsPersonal) : 0) +
            (this.gesamtabrechnung.anlagenKlasseNull ? parseFloat(this.gesamtabrechnung.anlagenKlasseNull) : 0) +
            (this.gesamtabrechnung.gebrauchVerbrauchHandel ? parseFloat(this.gesamtabrechnung.gebrauchVerbrauchHandel) : 0) +
            (this.gesamtabrechnung.verwaltungBetriebKlasse6 ? parseFloat(this.gesamtabrechnung.verwaltungBetriebKlasse6) : 0) +
            (this.gesamtabrechnung.verwaltungBetriebKlasse7 ? parseFloat(this.gesamtabrechnung.verwaltungBetriebKlasse7) : 0);      
            return ausgaben;          
        },       
        getAmountFromFormattedNumber(value) {
            var numAsString = value.split(".").join("").replace(",", ".");
            if (isNaN(numAsString)) { return null; }
            var number = parseFloat(numAsString);
            if (!number) return null;
            return number;
        },
        setFormattedValuesFromGesamtabrechnung() {
            var formattedKeys = Object.keys(this.formattedNumbers);

            for (var key of formattedKeys) {
                if (!this.gesamtabrechnung[key]) {
                    continue;
                }
                this.onPreisChanged(this.gesamtabrechnung[key].toString(), key);
            }
        },
        generatePdf() {
            var doc = new JsPDF()

            let x = 20
            let y = 40

            doc.setFontType('normal')
            doc.setFontSize(12)

            const logo = require('@/assets/img/logo.jpg')
            var imgLogo = new Image()
            imgLogo.src = logo
            const footerlogo = require('@/assets/img/footerlogo.png')
            var imgFooter = new Image()
            imgFooter.src = footerlogo
            doc.addImage(imgLogo, 'PNG', 140, 6)


            y += 5;
            doc.text(x, y, 'An die')
            doc.text(
                x,
                y + 5,
                'MKM Musik & Kunst Schulen Management Niederösterreich GmbH'
            )
            doc.text(x, y + 10, 'Neue Herrengasse 10')
            doc.text(x, y + 15, '3100 St. Pölten')

            doc.setFontType('bold')
            doc.setFontSize(15)
            
            doc.text('Gesamtabrechnung laut', 104, y + 30, 'center')
            doc.text('Rechnungsabschluss ' + (this.gesamtabrechnung.jahr - 1), 104, y + 36, 'center')
            doc.text(this.gesamtabrechnung.musikschuleName, 104, y + 42, 'center')
            
            y += 50;
            doc.setFontSize(11)
            doc.setFontType('normal')

            var formattedNumberKeys = Object.keys(this.formattedNumbers);
 
            for (const key of formattedNumberKeys) {
                if (!this.formattedNumbers[key]) { this.formattedNumbers[key] = '€ 0'; }

            }      
             
            doc.autoTable({
            head: [['Summe','']],
            body: [['B1. Mittelverwendung:',this.formattedNumbers.summeAusgaben],
            ['B2. Mittelaufbringung:',this.formattedNumbers.summeEinnahmen],
            ['B3. Differenz:', this.formattedNumbers.differenz]
                ],
            startY: y+10,
            styles: {
                fontSize: 13, 
            }
            });

            var einnahmenRows =  [['C1. Förderung (VRV +861):',this.formattedNumbers.einnahmenFoerderungen],
                ['C2. Elternbeiträge (VRV +810):',this.formattedNumbers.einnahmenSchulgeld],
                ['C3. Sonstige (VRV +829):', this.formattedNumbers.einnahmenSonstige], 
                ['C4. Gemeindebeiträge (VRV +862):', this.formattedNumbers.einnahmenGemeindebeitraege],
                ['C5. Weitere Förderungen ohne Musikschulförderung (VRV +861):', this.formattedNumbers.einnahmenGebaeude]
                ];
            doc.autoTable({
            head: [['Einzahlungen','', '', '']],
            body: einnahmenRows,
            startY: doc.lastAutoTable.finalY + 20,
            styles: {
                fontSize: 13, 
            },   
            columnStyles: {
                1: {halign: 'right'},
                3: {halign: 'right'},
            },
            });

            x=20;
            y=40;
            doc.autoTable({
            head: [['Auszahlungen','', '', '']],
            body: [
                ['D. Leistungen für Lehrpersonal gem. Klasse 5', this.formattedNumbers.lehrPersonal],
                ['E. Leistungen für Verwaltungspersonal gem. Klasse 5', this.formattedNumbers.verwaltungsPersonal],
                ['F. Anlagen gem. Klasse 0', this.formattedNumbers.anlagenKlasseNull],
                ['      F1. davon Ankauf Instrumente', this.formattedNumbers.anlagenKlasseNullWartenStimmen],
                ['G. Gebrauchs- und Verbrauchsgüter sowie Handelswaren gem. Klasse 4', this.formattedNumbers.gebrauchVerbrauchHandel],
                ['      G1. davon Ankauf Instrumente, Warten und Stimmen', this.formattedNumbers.anteilInstrumenteWartenStimmen],
                ['H. Sonstiger Verwaltungs- und Betriebsaufwand gem. Klasse 6', this.formattedNumbers.verwaltungBetriebKlasse6],
                ['I. Sonstiger Verwaltungs- und Betriebsaufwand gem. Klasse 7', this.formattedNumbers.verwaltungBetriebKlasse7]
                ],
            margin: {
                bottom: 25,
                top: 20,
            },
            startY: doc.lastAutoTable.finalY + 60,
            rowPageBreak: 'avoid',
            showHead: 'firstPage',
            styles: {
                fontSize: 13, 
            },
            columnStyles: {
                1: {halign: 'right', overflow: 'visible'},
            },
            });

            doc.setPage(2)
            y = 210

            doc.setFontSize(9)
            doc.text(x, y + 20, '_________________________________')
            doc.text(x, y + 25, 'Ort, Datum, Stempel')

            doc.setDrawColor(0, 0, 0);
            doc.setLineWidth(0.4);
            doc.circle(x + 83, y, 15, 'S')
            doc.text(x + 77, y + 1, 'Stempel')
            
            doc.text(x + 106, y + 20, '_________________________________')
            doc.text(x + 106, y + 24, 'Unterschrift Schulerhalterin bzw. Schulerhalter')

            doc.setFontSize(10)
            doc.setPage(1);
            doc.text('Seite 1 von 2', 17, 285, 'left');
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.setPage(2);
            doc.text('Seite 2 von 2', 17, 285, 'left');
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)

            doc.save('gesamtabrechnung.pdf');
        },
    },
    components: {
        FormHeader,
        FormSection,
        TextInput,
        TextBlock,
        DropDown,
        FileUpload
    },
    async created() {
        if (!this.hash) {
            this.formbehaviour.showGesamtabrechnungMissing = true;
            return;
        }      
        this.fetchTextBausteine();
        var {data} = await this.service.gesamtabrechnung.byhash(this.hash);

        //following lines ensure the comma is not lost, otherwise e.g. 123.45 becomes 12345
        var formattedKeys = Object.keys(this.formattedNumbers);
        for (var key of formattedKeys) {
            if (data[key])
            {
                var stringVal = (data[key]).toString().replace('.', ',');
                data[key] = stringVal;
            }
        }

        this.gesamtabrechnung = data;

        if (!this.gesamtabrechnung.xmlGesamtabrechnungFile) {
            this.gesamtabrechnung.xmlGesamtabrechnungFile = {
                subject: 'Upload - Rechnungsabschluss',
                filename: null,
                mimeType: null,
                body: null,
            };
        }

        this.formbehaviour.musikschuleIsSet = true;
        this.setFormattedValuesFromGesamtabrechnung();
    }
    
}
</script>
